<template>
  <div class="empresas">
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane class="paddingBody content" :label="$t('Listado de empresas')">
        <el-row>
          <el-col :span="24">
            <el-input
              :placeholder="$t('Búsqueda por RUT o nombre de la empresa')"
              prefix-icon="el-icon-search"
              v-model="search"
              class="search"
              size="medium"
            ></el-input>
            <el-button
              class="right"
              size="small"
              type="primary"
              @click="dialogVisible=true"
              icon="el-icon-edit"
            >{{$t('Nueva Empresa')}}</el-button>
          </el-col>
        </el-row>
        <el-row
          element-loading-text="Cargando..."
          element-loading-background="rgba(255, 255, 255)"
          v-loading="loading"
        >
          <el-table
            class="companyTable"
            :max-height="700"
            :data="paginar === false ? empresas : paginarEmpresas()"
            :cell-style="function () { return 'border-width: 1px; border-color: white white grey white;padding: 2px;'}"
            :row-style="function () { return 'background-color: white; padding: 0px;'}"
            :header-cell-style="function () { return 'background-color: #b7b7b7;color: black; padding: 0px; border-width: 2px; border-color: white;'}"
          >
            <el-table-column prop="rut" width="120" :label="$t('RUT')" sortable></el-table-column>
            <el-table-column prop="nombre" :label="$t('Nombre')" sortable></el-table-column>
            <el-table-column prop="contacto" :label="$t('Contacto')" sortable></el-table-column>
            <el-table-column prop="email" :label="$t('Correo electrónico contacto')" sortable></el-table-column>
            <el-table-column prop="fono" width="130" :label="$t('Fono')"></el-table-column>
            <el-table-column width="150" align="center">
              <template slot-scope="scope">
                <div class="ver" @click="elegirEmpresa(scope.row)">
                  <i class="el-icon-edit-outline"></i>
                  {{$t('Ver/editar')}}
                </div>
              </template>
            </el-table-column>
          </el-table>
          <br />
          <br />
          <center>
            <el-pagination
              :current-page="page"
              @prev-click="backPage"
              @next-click="nextPage"
              @current-change="currentPage"
              :page-size="6"
              layout="prev, pager, next"
              :total="totalPage"
            ></el-pagination>
          </center>
        </el-row>
      </el-tab-pane>
    </el-tabs>

    <!--Nueva empresa-->
    <el-dialog
      :title="$t('Crear empresa')"
      :visible="dialogVisible"
      width="50%"
      :before-close="handleClose"
    >
      <el-form label-position="top" :model="nuevo" ref="nuevo" :rules="rules">
        <el-form-item :label="$t('Nombre empresa')" prop="nombre">
          <el-input class="with-help-box" v-model="nuevo.nombre" placeholder></el-input>
          <el-popover
            class="help-box"
            placement="right"
            :title="$t('Nombre empresa')"
            width="200"
            trigger="hover"
            :content="$t('Escriba el nombre de la empresa')"
          >
            <i slot="reference" class="el-icon-question"></i>
          </el-popover>
        </el-form-item>
        <el-form-item :label="$t('RUT empresa')" prop="rut">
          <el-input class="with-help-box" v-model="nuevo.rut" placeholder></el-input>
          <el-popover
            class="help-box"
            placement="right"
            :title="$t('RUT empresa')"
            width="200"
            trigger="hover"
            :content="$t('Escriba el RUT de la empresa')"
          >
            <i slot="reference" class="el-icon-question"></i>
          </el-popover>
        </el-form-item>
        <br />
        <el-card>
          <div slot="header" class="clearfix">
            <span>{{$t('Información de contacto')}}</span>
          </div>
          <el-form-item :label="$t('Nombre')" prop="contacto">
            <el-input class="with-help-box" v-model="nuevo.contacto" placeholder></el-input>
            <el-popover
              class="help-box"
              placement="right"
              :title="$t('Nombre de contacto')"
              width="200"
              trigger="hover"
              :content="$t('Escriba el nombre de contacto de la empresa')"
            >
              <i slot="reference" class="el-icon-question"></i>
            </el-popover>
          </el-form-item>
          <el-form-item :label="$t('Email')" prop="email">
            <el-input class="with-help-box" v-model="nuevo.email" placeholder></el-input>
            <el-popover
              class="help-box"
              placement="right"
              :title="$t('Email de contacto')"
              width="200"
              trigger="hover"
              :content="$t('Escriba el correo electrónico del contacto')"
            >
              <i slot="reference" class="el-icon-question"></i>
            </el-popover>
          </el-form-item>
          <el-form-item :label="$t('Teléfono')" prop="fono">
            <el-input class="with-help-box" type="number" v-model="nuevo.fono" placeholder></el-input>
            <el-popover
              class="help-box"
              placement="right"
              :title="$t('Teléfono de contacto')"
              width="200"
              trigger="hover"
              :content="$t('Escriba el teléfono del contacto')"
            >
              <i slot="reference" class="el-icon-question"></i>
            </el-popover>
          </el-form-item>
        </el-card>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{$t('Cancelar')}}</el-button>
        <el-button type="primary" @click="submitForm('nuevo')">{{$t('Crear')}}</el-button>
      </span>
    </el-dialog>

    <!--Editar empresa-->
    <el-dialog
      :title="$t('Editar empresa')"
      :visible="editarVisible"
      width="50%"
      :before-close="handleClose"
    >
      <el-form label-position="top" :model="empresa" ref="empresa" :rules="rules">
        <el-form-item :label="$t('Nombre empresa')" prop="nombre">
          <el-input class="with-help-box" v-model="empresa.nombre" placeholder></el-input>
          <el-popover
            class="help-box"
            placement="right"
            :title="$t('Nombre empresa')"
            width="200"
            trigger="hover"
            :content="$t('Escriba el nombre de la empresa')"
          >
            <i slot="reference" class="el-icon-question"></i>
          </el-popover>
        </el-form-item>
        <el-form-item :label="$t('RUT empresa')" prop="rut">
          <el-input class="with-help-box" v-model="empresa.rut" placeholder></el-input>
          <el-popover
            class="help-box"
            placement="right"
            :title="$t('RUT empresa')"
            width="200"
            trigger="hover"
            :content="$t('Escriba el RUT de la empresa')"
          >
            <i slot="reference" class="el-icon-question"></i>
          </el-popover>
        </el-form-item>
        <br />
        <el-card>
          <div slot="header" class="clearfix">
            <span>{{$t('Información de contacto')}}</span>
          </div>
          <el-form-item :label="$t('Nombre')" prop="contacto">
            <el-input class="with-help-box" v-model="empresa.contacto" placeholder></el-input>
            <el-popover
              class="help-box"
              placement="right"
              :title="$t('Nombre de contacto')"
              width="200"
              trigger="hover"
              :content="$t('Escriba el nombre de contacto de la empresa')"
            >
              <i slot="reference" class="el-icon-question"></i>
            </el-popover>
          </el-form-item>
          <el-form-item label="Email" prop="email">
            <el-input class="with-help-box" v-model="empresa.email" placeholder></el-input>
            <el-popover
              class="help-box"
              placement="right"
              :title="$t('Email de contacto')"
              width="200"
              trigger="hover"
              :content="$t('Escriba el correo electrónico del contacto')"
            >
              <i slot="reference" class="el-icon-question"></i>
            </el-popover>
          </el-form-item>
          <el-form-item :label="$t('Teléfono')" prop="fono">
            <el-input class="with-help-box" type="number" v-model="empresa.fono" placeholder></el-input>
            <el-popover
              class="help-box"
              placement="right"
              :title="$t('Teléfono de contacto')"
              width="200"
              trigger="hover"
              :content="$t('Escriba el teléfono del contacto')"
            >
              <i slot="reference" class="el-icon-question"></i>
            </el-popover>
          </el-form-item>
        </el-card>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="editarVisible = false">{{$t('Cancelar')}}</el-button>
        <el-button type="primary" @click="editarEmpresa()">{{$t('Modificar')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Empresas",
  data() {
    return {
      dialogVisible: false,
      editarVisible: false,
      empresa: {},
      nuevo: {
        nombre: "",
        contacto: "",
        email: "",
        rut: "",
        fono: "",
        faena_id: this.$store.getters.role.faena_id
      },
      rules: {
        nombre: [
          {
            required: true,
            message: this.$t("Por favor, ingresa nombre"),
            trigger: "blur"
          }
        ],
        contacto: [
          {
            required: true,
            message: this.$t("Por favor, ingresa nombre del contacto"),
            trigger: "blur"
          }
        ],
        rut: [
          {
            required: true,
            message: this.$t("Por favor, ingresa RUT"),
            trigger: "blur"
          }
          // { validator: validaRut, trigger: 'blur' }
        ],
        email: [
          {
            required: true,
            message: this.$t("Por favor, ingresa correo electrónico"),
            trigger: "blur"
          },
          {
            type: "email",
            message: this.$t("Por favor, ingrese un correo electrónico válido"),
            trigger: "blur"
          }
        ],
        fono: [
          {
            required: true,
            message: this.$t("Por favor, ingresa teléfono"),
            trigger: "blur"
          }
          // { type: 'number', message: 'Por favor, ingrese un teléfono válido', trigger: 'blur,change' }
        ]
      },
      empresas: [],
      totalPage: 0,
      paginar: false,
      page: 1,
      search: ""
    };
  },
  created() {
    this.$store.dispatch("setTitle", this.$t("Administración de empresas"));
    this.$store.dispatch(
      "setSubTitle",
      this.$t("Inventario de riesgos HSE online")
    );
    this.listadoEmpresas(1, this.search);
  },
  watch: {
    search: function() {
      this.loading = true;
      this.debounceInputSearch();
    }
  },
  methods: {
    paginarEmpresas() {
      return this.empresas.slice((this.page - 1) * 6, this.page * 6);
    },
    debounceInputSearch: _.debounce(function() {
      this.page = 1;
      this.listadoEmpresas(this.page, this.search);
    }, 1200),
    currentPage(page) {
      this.page = page;
      this.listadoEmpresas(page, this.search);
    },
    nextPage(page) {
      this.page = page;
      this.listadoEmpresas(page, this.search);
    },
    backPage(page) {
      this.page = page;
      this.listadoEmpresas(page, this.search);
    },
    listadoEmpresas(page, search) {
      this.loading = true;
      var self = this;
      axios
        .get(
          `/empresas/getAllEmpresas/${
            this.$store.getters.role.faena_id
          }/${page}/${search === "" ? undefined : search}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then(response => {
          self.empresas = response.data.results;
          self.totalPage = response.data.total;
          self.paginar = response.data.paginar;
          self.loading = false;
        });
    },
    elegirEmpresa(empresa) {
      this.empresa = JSON.parse(JSON.stringify(empresa));
      this.empresa_id = JSON.parse(JSON.stringify(empresa))._id;
      this.editarVisible = true;
    },
    editarEmpresa() {
      if (
        this.empresa.nombre &&
        this.empresa.rut &&
        this.empresa.contacto &&
        this.empresa.fono &&
        this.empresa.email
      ) {
        this.editEmpresa(this.empresa).then(response => {
          if (response === true) {
            this.listadoEmpresas(this.page, this.search);
            this.empresa = {};
            this.editarVisible = false;
            this.$notify.success({
              title: this.$t("Creada"),
              message: this.$t("Empresa editada con éxito"),
              customClass: "notification"
            });
          } else {
            this.$alert(response.message, this.$t("Atención"), {
              type: "error"
            });
          }
        });
      } else {
        this.$alert(
          this.$t(
            "Debes ingresar nombre de la empresa, RUT, y los datos del contacto."
          ),
          this.$t("Atención"),
          {
            type: "error"
          }
        );
      }
    },
    handleClose(done) {
      this.dialogVisible = false;
      this.editarVisible = false;
      done();
    },
    ...mapActions(["getEmpresasFaena", "saveEmpresa", "editEmpresa"]),
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.saveEmpresa(this.nuevo).then(response => {
            if (response === true) {
              this.listadoEmpresas(this.page, this.search);
              this.dialogVisible = false;
              this.nuevo = {
                nombre: "",
                contacto: "",
                email: "",
                rut: "",
                fono: "",
                faena_id: this.$store.getters.role.faena_id
              };
            } else {
              this.errorSubmit(response);
            }
          });
          return true;
        }
        return false;
      });
    },
    errorSubmit(message) {
      this.$notify.error({
        title: this.$t("Error"),
        message,
        customClass: "notification"
      });
    }
  }
};
</script>

<style scoped>
.ver {
  cursor: pointer;
}
.right {
  text-align: right;
}
.companyTable {
  margin-top: 40px;
}
.search {
  max-width: 450px;
  float: left;
}
.content {
  min-height: 50vh;
}
.btn-excel {
  margin-right: 10px;
}
</style>
